import React, { useEffect, useState } from 'react'
import { CustomDropdown } from '../../../../components'
import { getCities } from '../../../../services/api/https/system/system.http'
import { ufIdDoMunicipio } from './ciot.util'

const cidadesPorUf = new Map()

function carregarCidades(ufId) {
  if (!cidadesPorUf.has(ufId)) {
    cidadesPorUf.set(
      ufId,
      getCities(ufId).catch(error => {
        cidadesPorUf.delete(ufId)
        throw error
      }),
    )
  }
  return cidadesPorUf.get(ufId)
}

export default function SelectMunicipioCiot({
  labelUf = 'UF:*',
  labelCidade = 'Cidade:*',
  codigo,
  ufSigla = null,
  ufs,
  onChange,
  onError,
}) {
  const [ufId, setUfId] = useState(ufIdDoMunicipio(codigo))
  const [cidades, setCidades] = useState([])

  useEffect(() => {
    const ufDoCodigo = ufIdDoMunicipio(codigo)
    if (ufDoCodigo) setUfId(ufDoCodigo)
  }, [codigo])

  useEffect(() => {
    if (ufId || !ufSigla || !ufs) return
    const ufDaSigla = ufs.find(item => item.uf === ufSigla)
    if (ufDaSigla) setUfId(ufDaSigla.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ufs, ufSigla])

  useEffect(() => {
    let ativo = true
    if (!ufId) {
      setCidades([])
      return undefined
    }
    carregarCidades(ufId)
      .then(lista => ativo && setCidades(lista))
      .catch(error => ativo && onError(error))
    return () => {
      ativo = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ufId])

  const uf = (ufs || []).find(item => item.id === ufId) || null
  const cidade = cidades.find(item => Number(item.id) === Number(codigo)) || null

  return (
    <div style={{ display: 'flex', gap: 5 }}>
      <div style={{ width: 80, flexShrink: 0 }}>
        <CustomDropdown
          optionLabel="uf"
          options={ufs}
          value={uf}
          label={labelUf}
          filter={true}
          onChange={value => {
            setUfId(value ? value.id : null)
            onChange(null)
          }}
        />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <CustomDropdown
          optionLabel="name"
          options={cidades}
          value={cidade}
          label={labelCidade}
          filter={true}
          disabled={!uf}
          onChange={value => onChange(value ? { codigo: value.id, nome: value.name } : null)}
        />
      </div>
    </div>
  )
}
